<template>
  <div :class="['row', (isSubmenu == 'false') ? 'px-2' : '']">
    <router-link v-if="!endpage && !subpage" @click="setBackpage()" 
      :to="pathTo" :class="['btn', menuClass]">
      <i v-if="icon !== ''" :class="[icon, 'me-2']"></i>
      {{ menuItem.title }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: ['menuItem', 'pathTo', 'icon', 'menuClass', 'isSubmenu', 'subpage', 'endpage', 'backpage'],
  methods: {
		setBackpage() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			if (this.backpage) this.$store.dispatch("setBackpage", this.backpage)
		}
  },
}
</script>

<style>
.fa-level-up-alt {
  transform: rotate(90deg) !important;
}
</style>

<style scoped>
</style>
